import Heading from '@axa-japan/design-system-react/Heading';
import Text from '@axa-japan/design-system-react/Text';
import App from './App';

import useDeviceDetection from './hooks/useDeviceDetection';

const MobileErrorPage = () => {
  return (
    <div className="grid h-full w-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="mb-2">
        <svg
          className="w-12 h-12 text-statusWarning"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            fillRule="evenodd"
            d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0V8Zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      <div className="p-2">
        <Heading as="h3" size="lg" align="center">
          アクセス拒否
        </Heading>
        <Text size="md" weight="regular" align="center">
          このページのアクセスは、モバイル端末では制限されています。
        </Text>
      </div>
    </div>
  );
};

const RequestInterceptor = () => {
  const deviceType = useDeviceDetection();

  return deviceType === 'Mobile' ? <MobileErrorPage /> : <App />;
};

export default RequestInterceptor;
